export class Uom {
    id: number;
    code: string;
    name: string;
    state: any;
}